/**
 * fetch( 链接, 参数, 方法, 是否需要token )
**/
import http from './public'
// 登录
export const userLogin = (params) => {
  return http.fetch('api/h5app/wxapp/login', params, 'POST')
}
// 注销登录
export const userLogout = (params) => {
  return http.fetch('api/h5app/wxapp/member/logout', params, 'POST', true)
}
// 注销登录
export const userLogoutStatus = (params) => {
  return http.fetch('api/h5app/wxapp/member/logout/status', params, 'GET')
}
// 获取登录二维码
export const getCodeLogin = (params) => {
  return http.fetch('api/h5app/wxapp/pcloginqrcode', params, 'GET')
}
// 二维码登录
export const userCodeLogin = (params) => {
  return http.fetch('api/h5app/wxapp/oauth/login/valid', params, 'GET')
}
// 获取注册参数
export const getRegisterParam = (params) => {
  return http.fetch('api/h5app/wxapp/member/setting', params, 'GET')
}
// 注册账号
export const register = (params) => {
  return http.fetch('api/h5app/wxapp/member', params, 'POST')
}
// 找回密码
export const retrieve = (params) => {
  return http.fetch('api/h5app/wxapp/member/reset/password', params, 'POST')
}
// 获取验证码图片
export const getimageData = (params) => {
  return http.fetch('api/h5app/wxapp/member/image/code', params, 'GET')
}
// 获取手机验证码
export const getSmsCode = (params) => {
  return http.fetch('api/h5app/wxapp/member/sms/code', params, 'GET')
}
// 获取七牛token
export const getQiniuToken = (params) => {
  return http.fetch('api/h5app/wxapp/espier/image_upload_token', params, 'GET')
}
// 用户信息
export const userInfo = (params) => {
  return http.fetch('api/h5app/wxapp/member', params, 'GET', true)
}
// 上传图片
export const uploadAvatar = (params) => {
  return http.fetch('api/h5app/wxapp/member', params, 'PUT', true)
}
// 修改头像
export const updateheadimage = (params) => {
  return http.fetch('/member/updateheadimage', params, 'POST', true)
}
// // 首页接口
// export const productHome = (params) => {
//   return http.fetch('/goods/home', params, 'GET')
// }
// 首页接口
export const getCateList = (params) => {
  return http.fetch('api/h5app/wxapp/goods/category', params, 'GET')
}
// // 推荐板块
// export const recommend = (params) => {
//   return http.fetch('/goods/recommend', params, 'GET')
// }
// // 极验验证码
// export const geetest = (params) => {
//   return http.fetch('/member/geetestInit?t=' + (new Date()).getTime(), params, 'GET')
// }
// logo
export const getLogo = (params) => {
  return http.fetch('api/h5app/wxapp/company/setting', params, 'GET')
}
// 优惠券列表
export const getCoupon = (params) => {
  return http.fetch('api/h5app/wxapp/user/newGetCardList', params, 'GET', true)
}
// 获取注册协议
export const getAgreement = (params) => {
  return http.fetch('api/h5app/wxapp/member/agreement', params, 'GET')
}
// 获取文章
export const getArticle = (params) => {
  return http.fetch(`api/h5app/wxapp/article/management/${params.article_id}`, params, 'GET')
}
// 获取商品详情二维码
export const getCodeGoods = (params) => {
  return http.fetch('api/h5app/wxapp/pcqrcode', params, 'GET')
}
// 获取店铺二维码
export const getCodeShop = (params) => {
  return http.fetch('api/h5app/wxapp/pcqrcode', params, 'GET')
}
// 获取用户是否有设计师标签
export const getDesignTags = (params) => {
  return http.fetch(`api/h5app/wxapp/member/design/token`, params, 'GET', true);
}
// 设计圈绑定邮箱
export const updateDesignEmail = (params) => {
  return http.fetch(`api/h5app/wxapp/member/design/bind?design_email=${params.email}`, { ...params.email }, 'POST', true);
}



// WEBPACK FOOTER //
// ./src/api/index.js